import { makeStyles } from "@mui/styles";
import { AVATAR_SIZE } from "./utils";

const avatarDimensions = {
  width: AVATAR_SIZE,
  height: AVATAR_SIZE,
  minWidth: AVATAR_SIZE,
  minHeight: AVATAR_SIZE,
  fontSize: "10px",
  fontWeight: 600,
  border: "2px solid #fff",
  boxSizing: "content-box" as const,
  padding: 0,
  lineHeight: 1,
};

export const useStyles = makeStyles({
  memberAvatar: {
    "&&": {
      ...avatarDimensions,
      position: "relative",
    },
  },
  memberAvatarClickable: {
    "&&": {
      cursor: "pointer",
    },
  },
  memberAvatarCopy: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    backgroundColor: "rgba(0, 0, 0, 0.55)",
    opacity: 0,
    transition: "opacity 0.2s",
  },
  memberAvatarCopyVisible: {
    opacity: 1,
  },
  memberAvatarCopyIcon: {
    "&&": {
      fontSize: "12px",
      color: "#fff",
    },
  },
  surplusAvatar: {
    "&&": {
      ...avatarDimensions,
      backgroundColor: "#bdbdbd",
      color: "#fff",
    },
  },
  addAvatar: {
    "&&": {
      ...avatarDimensions,
      backgroundColor: "#F3F4F6",
      color: "#6B7280",
      boxShadow: "inset 0 0 0 1px #D1D5DB",
      cursor: "pointer",
      transition: "background-color 0.2s ease, box-shadow 0.2s ease",
      "&:hover": {
        backgroundColor: "#E5E7EB",
        boxShadow: "inset 0 0 0 1px #9CA3AF",
      },
    },
  },
  addAvatarOverlap: {
    "&&": {
      marginLeft: -8,
    },
  },
  addAvatarIcon: {
    "&&": {
      fontSize: "12px",
      color: "#6B7280",
    },
  },
  showAllButton: {
    "&&": {
      minWidth: "auto",
      padding: 0,
      fontSize: "11px",
      fontWeight: 500,
      lineHeight: 1.4,
      textTransform: "none",
      textDecoration: "underline",
    },
  },
  listTable: {
    marginTop: 8,
    borderRadius: 4,
    overflow: "hidden",
    border: "1px solid #e5e7eb",
  },
  listTableCell: {
    "&&": {
      fontSize: "12px",
      lineHeight: 1.4,
      color: "#374151",
      borderColor: "#e5e7eb",
      verticalAlign: "middle",
    },
  },
  listTableCellEmail: {
    "&&": {
      padding: "6px 8px",
      wordBreak: "break-all",
    },
  },
  listTableCellCopy: {
    "&&": {
      padding: 2,
      width: 30,
    },
  },
  listTableCopyButton: {
    padding: 2,
    width: 24,
    height: 24,
  },
});
